import { useState } from 'react';

import TabTitle from '../../components/atoms/tab-title/tab-title';
import { MetaPages } from '../../enums/pages';
import VideoCard from '../../components/molecules/video-card/video-card';
import { filterSelectedDropdownValue } from '../../utils/filter';
import { VideoModel } from '../../interface/inspirations-and-planning';
import DropdownTab from '../../components/atoms/dropdown-tab/dropdown-tab';
import MarginSpacing from '../../components/atoms/margin-spacing/margin-spacing';
import SectionContainer from '../../components/atoms/section-container/section-container';
import SectionDescription from '../../components/atoms/section-description/section-description';
import SectionTitle from '../../components/atoms/section-title/section-title';
import Tabs from '../../components/molecules/tabs/tabs';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import {
  getInspirationsAndPlanningBannerContent,
  getInspirationsAndPlanningVideos,
  getVideoGalleryDropdownContent,
  getVideoGalleryHeaderContent
} from '../../services/inspirations-and-planning';
import { inspirationsAndPlanningRoutes } from '../../config/routes/pages';
import { ContentType, DropdownType } from '../../types/content';
import { VideoGalleryContentTabs } from '../../enums/contentTabs';

type IndexProps = {
  inspirationsAndPlanningBannerContent: ContentType;
  inspirationsAndPlanningVideos: VideoModel[];
  videoGalleryDropdownContent: DropdownType;
  videoGalleryHeaderContent: ContentType;
};

export function Index(props: IndexProps) {
  const {
    inspirationsAndPlanningBannerContent,
    inspirationsAndPlanningVideos,
    videoGalleryDropdownContent,
    videoGalleryHeaderContent
  } = props;

  const { options } = videoGalleryDropdownContent;
  const [firstOption] = options;

  const { description, title } = videoGalleryHeaderContent;
  const [currentOption, setCurrentOption] = useState(firstOption);

  const filteredVideos = inspirationsAndPlanningVideos.filter((video) => {
    return filterSelectedDropdownValue(
      currentOption,
      VideoGalleryContentTabs.ALL_VIDEO_CHANNELS,
      video.attributes.Category,
      inspirationsAndPlanningVideos
    );
  });

  const renderVideoGalleryVideos = filteredVideos.map((videoItem) => {
    return (
      <VideoCard
        key={videoItem.attributes.Title}
        Title={videoItem.attributes.Title}
        Youtube_link={videoItem.attributes.Youtube_link}
      />
    );
  });

  return (
    <>
      <TabTitle page={MetaPages.VIDEO_GALLERY} />
      <HeaderContainer {...inspirationsAndPlanningBannerContent} />
      <Tabs tabItems={inspirationsAndPlanningRoutes} />
      <SectionContainer>
        <div className="lg:mx-14 mb-10">
          <SectionTitle title={title} />
          <SectionDescription isCentered description={description as string} />
        </div>
        <MarginSpacing margin="mb-10" />
        <div className="text-center">
          <DropdownTab
            dropdownWidthMobile="w-48"
            options={options}
            value={currentOption}
            setTab={setCurrentOption}
          />
          <div className="grid lg:grid-cols-2 gap-4 mt-12 md:px-48 lg:p-4">
            {renderVideoGalleryVideos}
          </div>
        </div>
      </SectionContainer>
    </>
  );
}

export async function getStaticProps() {
  const inspirationsAndPlanningBannerContent =
    await getInspirationsAndPlanningBannerContent();
  const inspirationsAndPlanningVideos =
    await getInspirationsAndPlanningVideos();
  const videoGalleryDropdownContent = await getVideoGalleryDropdownContent();
  const videoGalleryHeaderContent = await getVideoGalleryHeaderContent();

  return {
    props: {
      inspirationsAndPlanningBannerContent,
      inspirationsAndPlanningVideos,
      videoGalleryDropdownContent,
      videoGalleryHeaderContent
    }
  };
}

export default Index;
